import { __extends } from "tslib";
import { UpdateDestinationInput, UpdateDestinationOutput } from "../models/models_0";
import { deserializeAws_json1_1UpdateDestinationCommand, serializeAws_json1_1UpdateDestinationCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateDestinationCommand = /** @class */ (function (_super) {
    __extends(UpdateDestinationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateDestinationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateDestinationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "FirehoseClient";
        var commandName = "UpdateDestinationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: UpdateDestinationInput.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateDestinationOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateDestinationCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1UpdateDestinationCommand(input, context);
    };
    UpdateDestinationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1UpdateDestinationCommand(output, context);
    };
    return UpdateDestinationCommand;
}($Command));
export { UpdateDestinationCommand };
//# sourceMappingURL=UpdateDestinationCommand.js.map